import { Bot } from "../types/bot.type";
import CoinSelector from "./CoinSelector";
import QuoteAssetSelector from "./QuoteAssetSelector";
import TickerIntervalSelector from "./TickerIntervalSelector";

interface Props {
  bot: Bot;
  updateBot: (bot: Bot) => void;
}

const GlobalConfig: React.FC<Props> = ({ bot, updateBot }) => {
  return (
    <>
      <QuoteAssetSelector bot={bot} updateBot={updateBot} />
      <CoinSelector bot={bot} updateBot={updateBot} />
      <TickerIntervalSelector bot={bot} updateBot={updateBot} />
    </>
  );
};

export default GlobalConfig;
